<template>
  <BreadCrumb PageTitle="Détails sur les propositions de réponse" />
  <ViewPropositionReponse />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ViewPropositionReponse from "@/components/PropositionReponse/ViewPropositionReponse.vue";

  export default defineComponent({
    name: "ViewElectionPage",
    components: {
      BreadCrumb,
      ViewPropositionReponse,
    },
  });
</script>